import {deleteAction, getAction, postAction} from '../index'


// 数据源分页查询
export const copyInterface = (param) => getAction('/easyapi/copy', param)
export const deleteInterface = (param) => deleteAction('/easyapi/delete', param)
export const resolveMeta = (param) => postAction('/easyapi/meta/resolveMeta', param)
export const saveMeta = (param) => postAction('/easyapi/meta/saveMeta', param)
export const getMeta = (param) => postAction('/easyapi/meta/getMeta', param)
export const saveParams = (param) => postAction('/easyapi/saveParams', param)
export const listFieldInfo = (param) => postAction('/easydata/view/selectData', param)
export const exportFile = (param) => postAction('/easyapi/exportFile', param)
export const importInterface = (param) => postAction('/easyapi/importInterface', param)
export const jobCall = (param) => postAction('/easyapi/job/call', param)

export const updateDepend = (param) => postAction('/easyapi/updateDepend', param)

export const saveDepend = (param) => postAction('/easyapi/saveDepend', param)
// 批量导出
export default {
  copyInterface,
  deleteInterface,
  resolveMeta,
  saveMeta,
  getMeta,
  listFieldInfo,
  saveParams,
  importInterface,
  jobCall,
  saveDepend,
  updateDepend
}
